import { lazy } from 'react';

const Card = lazy(() => import('./Card'));

export { Card };
